<template>
  <div class="equipmentManagement-page">
    <div class="all-content-container">
      <el-tabs :tab-position="tabPosition" style="height: 200px" v-model="activeName2">
        <el-tab-pane label="环境模型" name="first">
          <hj1></hj1>
        </el-tab-pane>
        <!-- <el-tab-pane label="分组类型" name="second">
          <groupTypeManagement></groupTypeManagement>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import hj1 from '../deviceManagement/hj1'
import groupTypeManagement from '../deviceManagement/groupTypeManagement'

export default {
  props: {
    message: {
      type: String,
      default: 'first'
    }
  },
  components: {
    // groupingManagement,
    hj1,
    groupTypeManagement
  },
  data() {
    return {
      tabPosition: 'left',
      activeName2: 'first'
    }
  },
  created() {
    this.activeName2 = this.message
    this.$forceUpdate()
  }
}
</script>
<style lang="scss">
@import '@/style/equipmentManagement.scss';
</style>
